import React from "react";
import "./App.css";
import MainWhole from "./components/MainWhole";

function App() {
  return (
    <>
      <MainWhole />
    </>
  );
}

export default App;
